import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MaxExposedPlayersValidator extends BaseValidator {
    private minExposureLimit: number = 100;
    private exposureMinPropNames: string[] = [];

    protected runValidation(): void {
        // @ts-ignore
        const {exposureMinPropNames = []} = this.dependencies;

        this.exposureMinPropNames = exposureMinPropNames;

        if (this.isMinExposureExceeded()) {
            this.addError('The minimum exposure was exceeded for some player, please adjust.');
        }
    }

    private isMinExposureExceeded(): boolean {
        // @ts-ignore
        const {players} = this.dependencies;

        for (let player of players.getAllAsArr()) {
            let playersTotalExposureMin = 0;
            this.exposureMinPropNames.map((propName) => {
                if (propName in player) {
                    playersTotalExposureMin += player[propName];
                }
            });

            if (this.minExposureLimit < playersTotalExposureMin) {
                return true;
            }
        }

        return false;
    }
}

export {MaxExposedPlayersValidator};
